import { createSlice } from '@reduxjs/toolkit'

const CreateSessionReducer = createSlice({
    name: "CreateSession/reducer",

    initialState:{
        activeStep:0,
        imageSelectedData:"",
        imageFormFilled:""
    },

    reducers : {
        sessionDetails:(state,action) => {state.sessionDetails = action.payload},
        systemSpecification :  (state,action) => {state. systemSpecification = action.payload},
        scheduleTraining: (state,action) => {state. scheduleTraining = action.payload},
        studentDetails: (state,action) => {state. studentDetails = action.payload},
        cloudType: (state,action) => {state. cloudType = action.payload}, 
    }
})
export const { sessionDetails, systemSpecification, scheduleTraining, studentDetails ,cloudType} = CreateSessionReducer.actions
export const CreateSession = CreateSessionReducer.reducer;